import { useUserService } from '~/composables/useUserService'

export default defineNuxtRouteMiddleware(async () => {
	try {
		const { user: userService } = useUserService()
		const { data } = await userService.me()
		const response = data.value

		if (!response?.data?.user) {
			return navigateTo('/admin/login')
		}
	} catch (error) {
		return navigateTo('/admin/login')
	}
})
